export const dlr = {
  agencyCode: '405',
  name: 'Texas Department of Public Safety',
  shortName: 'Department of Public Safety',
  slug: 'dlr',
};
